import { SessionTimeoutDialog } from "../../shared/components/SessionTimeoutDialog";
import Form from "./Form";
import useAboutYou from "./hooks/useAboutYou";

export const AboutYou: React.FC = () => {
  const props = useAboutYou();
  return (
    <>
      <Form {...props} />
      <SessionTimeoutDialog />
    </>
  );
};

export default AboutYou;
